import request from "../../../request";

export default {
  state: {
    menuOpened: false,
  },
  getters: {
    menuOpened: state => state.menuOpened,
  },
  mutations: {
    setMenuOpened(state, payload) {
      state.menuOpened = payload;
    }
  },
  actions: {
    setMenuOpened({ commit }, payload) {
      commit("setMenuOpened", payload);
    },

    uploadPhoto(_, payload) {
      return request.post('image-upload', payload);
    }
  },
}
